import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Gift, Loader2, Lock, Mail } from "lucide-react";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { authed, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@wonderparcel.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (authed) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back \uD83D\uDC9D");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password.");
    } finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center wp-hero-gradient px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <img src="/logo.jpg" alt="Wonder Parcel" className="h-16 w-16 rounded-full object-cover shadow-wp-soft ring-1 ring-wp-beige-200" />
          <h1 className="mt-3 font-display text-2xl">Wonder Parcel Admin</h1>
          <p className="text-sm text-wp-ink-muted">Sign in to manage your store</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-wp-xl border border-border bg-card p-6 shadow-wp-card">
          <div>
            <Label className="mb-1.5 block text-sm">Email</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-wp-ink-muted" />
              <Input value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-wp-md pl-9" data-testid="admin-login-email" />
            </div>
          </div>
          <div>
            <Label className="mb-1.5 block text-sm">Password</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-wp-ink-muted" />
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-wp-md pl-9" data-testid="admin-login-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-xl bg-wp-rose-strong py-5 text-white hover:brightness-105" data-testid="admin-login-submit">
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null} Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}
